export const pagesNames = {
  state: {
    pages: 'pages'
  },
  mutations: {
    LOAD_PAGE: 'LOAD_PAGE'
  },
  actions: {},
  getters: {
    getPage: 'getPage'
  }
}

export default pagesNames
